export default __webpack_public_path__ + "5aa5b82bf3b3c955da7b46e69573c8b1.png";